module.exports = __webpack_public_path__ + "src/assets/img/engine_four.5ce605d3.svg";